import { useContext } from "react";
import TableContext from "../../task/TableContext";
import SearchInput from "../../shared/components/SearchInput";
import { ConsolidatedClientTableContextValues } from "../providers/ConsolidatedClientTableProvider";
import AdvancedFilters, {
  AdvancedFiltersButton
} from "../../shared/components/AdvancedFilters";
import { FilterCollection } from "../../../services/FilterService";
import CompanyService from "../../../services/CompanyService";
import ConsolidatedService from "../../../services/ConsolidatedService";
import { ButtonTooltipIcon } from "../../shared/components/ButtonTooltipIcon";
import { TranslationService } from "../../../services/TranslationService";

const ConsolidatedClientFilterContainer = () => {
  const tableContext = useContext(
    TableContext
  ) as ConsolidatedClientTableContextValues;
  const { applySearch, applyFilters, request, response } = tableContext;

  const applyFilter = (filters: string[]) => {
    applyFilters({ extraFilters: filters });
  };

  const doExport = () => {
    ConsolidatedService.exportClients(request, response?.itemCount ?? 0);
  };

  return (
    <>
      <div className="genericHeader">
        <div className="actionButtonsHeader">
          {CompanyService.canDo("export") && (
            <ButtonTooltipIcon
              title={TranslationService.translate.Export}
              icon="fa-light fa-arrow-down-to-line"
              onClick={doExport}
            />
          )}
          <AdvancedFiltersButton />
        </div>
        <div className="searcherFilterHeader" style={{ height: 40 }}>
          <SearchInput onSearch={applySearch} autosearch={false} />
        </div>
      </div>
      <AdvancedFilters
        page={FilterCollection.ConsolidatedClient}
        onFilterApply={applyFilter}
      />
    </>
  );
};

export default ConsolidatedClientFilterContainer;
